import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'Valeria',
  city: 'Buenos Aires'
}, {
  name: 'Marina',
  city: 'Córdoba'
}, {
  name: 'Romina',
  city: 'Rosario'
}, {
  name: 'Carla',
  city: 'Mendoza'
}, {
  name: 'Julieta',
  city: 'Salta'
}, {
  name: 'Sofía',
  city: 'Tucumán'
}, {
  name: 'Luciana',
  city: 'La Plata'
}, {
  name: 'Camila',
  city: 'Mar del Plata'
}, {
  name: 'Elena',
  city: 'Santa Fe'
}, {
  name: 'Paula',
  city: 'Neuquén'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const interval = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-50 bg-white rounded-2xl shadow-premium border border-brand-petroleum/5 p-4 pr-8 flex items-center gap-4 max-w-[320px] backdrop-blur-md" style={{
    animation: 'popup-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards',
    willChange: 'transform, opacity'
  }} data-id="element-268">
      <div className="bg-brand-gold-warm/10 p-2 rounded-xl border border-brand-gold-warm/20" data-id="element-269">
        <CheckCircle2 size={24} className="text-brand-gold-warm" data-id="element-270" />
      </div>
      <div data-id="element-271">
        <p className="text-xs text-brand-petroleum leading-tight font-bold tracking-tight" data-id="element-272">
          {currentBuyer.name} de {currentBuyer.city}
        </p>
        <p className="text-[9px] text-brand-medium-grey mt-1 font-semibold uppercase tracking-widest leading-tight" data-id="element-273">
          acaba de comprar el Kit Tarot Listo
        </p>
      </div>
      <style data-id="element-274">{`
        @keyframes popup-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>;
}